module.exports = __webpack_public_path__ + "static/media/up.39f1eb0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/up.svg
// module id = 305
// module chunks = 0